// ---- Enums match your Python names ----
export type ArtifactType = 'WORKPLAN';
export type SPWStatus = 'PENDING' | 'IN_PROGRESS' | 'DONE';

export enum StructuredProcessArtifactType{
  WORKPLAN = 'WORKPLAN'
}

export enum StructuredProcessWorkplanStatusEnum{
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE'
}

// ---- Base artifact ----
export interface StructuredProcessArtifact {
  id: string;
  userId: string;
  structuredProcessId: string;
  type: StructuredProcessArtifactType; // always 'WORKPLAN' here
}

// ---- Task & Milestone ----
export interface StructuredProcessWorkplan_Task {
  idx: number;
  name: string;
  description?: string | null;
  dueDate?: string | null;      // ISO string
  updatedAt?: string | null;    // ISO string
  completedAt?: string | null;  // ISO string
  status: StructuredProcessWorkplanStatusEnum;            // PENDING | IN_PROGRESS | DONE
}

export interface StructuredProcessWorkplan_Milestone {
  idx: number;
  name: string;
  description?: string | null;
  dueDate?: string | null;
  updatedAt?: string | null;
  completedAt?: string | null;
  status: StructuredProcessWorkplanStatusEnum;
  tasks: StructuredProcessWorkplan_Task[];
}

// ---- Workplan artifact ----
export interface StructuredProcessArtifactWorkplan extends StructuredProcessArtifact {
  name?: string | null;
  description?: string | null;
  dueDate?: string | null;
  updatedAt?: string | null;
  milestones: StructuredProcessWorkplan_Milestone[];
}
